import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_71tesjzfzj: FaireBrandEntity = {
  token: "b_71tesjzfzj",
  type: "brand",
  name: "Elevated Faith",
  avatarUrl:
    "https://cdn.faire.com/fastly/66477c08f0782478b7560130903f40df599e283331c0de45b1d379283587d3ba.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/2ffb014c4d9c71709aff93e561e653bf9f557e741f7c0749f6adbc3c1f222c0b.png",
  logoUrl:
    "https://cdn.faire.com/fastly/66477c08f0782478b7560130903f40df599e283331c0de45b1d379283587d3ba.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/2ffb014c4d9c71709aff93e561e653bf9f557e741f7c0749f6adbc3c1f222c0b.png",
  location: "Oshkosh, WI, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 163,
  isTopShop: true,
  isInsider: true,
  description:
    "Elevated Faith creates conversation starters: jewelry and apparel that open doors for wearers to tell friends and strangers about their faith.\n\nWe give a portion of every sale to world changing charities & other organizations around the world to practically improve people’s lives and share love and hope to a world that desperately needs it.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:42.475Z",
    importedBy: "entity-db-cli",
  },
};
